import { render, staticRenderFns } from "./ArceClient.vue?vue&type=template&id=cfabf5f6&"
import script from "./ArceClient.vue?vue&type=script&lang=js&"
export * from "./ArceClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports